import { Controller } from "@hotwired/stimulus"
import { get, set } from "../lib/session_store"

// Global ⌘K / Ctrl+K command palette.
// Phase 1: nav + actions + recents. Phase 2 (subsystem A): a context-aware
// "Compare this lap" section + a "refs" reference-browser page, shown on
// lap-analysis views (detected via a [data-cmdk-context] element).

const ICONS = {
  search:
    "M11 4a7 7 0 1 0 4.2 12.6l3.6 3.6 1.4-1.4-3.6-3.6A7 7 0 0 0 11 4Zm0 2a5 5 0 1 1 0 10 5 5 0 0 1 0-10Z",
  dashboard: "M3 3h8v8H3V3Zm10 0h8v5h-8V3ZM3 13h8v8H3v-8Zm10 3h8v5h-8v-5Z",
  events: "M4 18h3V9H4v9Zm6.5 0h3V4h-3v14Zm6.5 0h3v-7h-3v7Z",
  friends:
    "M9 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm7 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM2 19c0-2.6 3-4.5 7-4.5s7 1.9 7 4.5v1H2v-1Zm16.5-4.3c2.1.5 3.5 1.8 3.5 3.8v1.5h-4v-1c0-1.7-.7-3.1-1.8-4.1l2.3-.2Z",
  calendar:
    "M7 2v2H5a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-2V2h-2v2H9V2H7Zm12 7v10H5V9h14Z",
  activity: "M3 12h4l3 8 4-16 3 8h4",
  connection:
    "M12 2v3m0 14v3m10-10h-3M5 12H2m17 0a7 7 0 1 1-14 0 7 7 0 0 1 14 0Zm-4 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z",
  settings:
    "M19.14 12.94c.04-.31.06-.63.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58a.49.49 0 0 0 .12-.61l-1.92-3.32a.49.49 0 0 0-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54a.48.48 0 0 0-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96a.48.48 0 0 0-.59.22L2.74 8.87a.48.48 0 0 0 .12.61l2.03 1.58c-.05.3-.07.62-.07.94 0 .32.02.64.07.94l-2.03 1.58a.49.49 0 0 0-.12.61l1.92 3.32c.13.24.42.33.66.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.04.24.23.41.47.41h3.84c.24 0 .44-.17.48-.41l.36-2.54c.59-.24 1.12-.56 1.62-.94l2.39.96c.24.1.53 0 .66-.22l1.92-3.32a.49.49 0 0 0-.12-.61l-2.01-1.58ZM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6Z",
  help: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm0 14.2a1.1 1.1 0 1 1 0-2.2 1.1 1.1 0 0 1 0 2.2Zm1.6-5.3c-.6.5-.8.8-.8 1.5h-1.6c0-1.2.4-1.9 1.2-2.5.6-.5.9-.8.9-1.3 0-.6-.5-1-1.2-1-.8 0-1.3.5-1.4 1.3l-1.6-.3C9 7.9 10.1 7 11.9 7c1.7 0 3 .9 3 2.4 0 1-.5 1.6-1.3 2.2Z",
  clock:
    "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm0 2a7 7 0 1 1 0 14 7 7 0 0 1 0-14Zm-1 3v5l4 2 .8-1.5L12.5 11V8H11Z",
  spark: "M12 2l1.8 5.4L19 9l-5.2 1.6L12 16l-1.8-5.4L5 9l5.2-1.6L12 2Z",
  theme: "M12 3a9 9 0 1 0 9 9c0-.5 0-.9-.1-1.4A6 6 0 0 1 12 3Z",
  arrowr: "M5 11h11.2l-4.6-4.6L13 5l7 7-7 7-1.4-1.4 4.6-4.6H5v-2Z",
  chevronr: "M9.3 8.1 13.2 12l-3.9 3.9 1.4 1.4 5.3-5.3-5.3-5.3-1.4 1.4Z",
  close:
    "M6.4 5 12 10.6 17.6 5 19 6.4 13.4 12 19 17.6 17.6 19 12 13.4 6.4 19 5 17.6 10.6 12 5 6.4 6.4 5Z",
  swap: "M7.5 21 3 16.5m0 0L7.5 12M3 16.5h13.5m0-9L21 7.5m0 0L16.5 3M21 7.5H7.5",
  check: "M20 6 9 17l-5-5",
  trophy:
    "M5.166 2.621v.858c-1.035.148-2.059.33-3.071.543a.75.75 0 0 0-.584.859 6.753 6.753 0 0 0 6.138 5.6 6.73 6.73 0 0 0 2.743 1.347A6.707 6.707 0 0 1 9.279 15H8.54c-1.036 0-1.875.84-1.875 1.875V19.5h-.75a2.25 2.25 0 0 0-2.25 2.25c0 .414.336.75.75.75h15.17a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-2.25-2.25h-.75v-2.625c0-1.036-.84-1.875-1.875-1.875h-.739a6.706 6.706 0 0 1-1.112-3.173 6.73 6.73 0 0 0 2.743-1.347 6.753 6.753 0 0 0 6.139-5.6.75.75 0 0 0-.585-.858 47.077 47.077 0 0 0-3.07-.543V2.62a.75.75 0 0 0-.658-.744 49.22 49.22 0 0 0-6.093-.377c-2.063 0-4.096.128-6.093.377a.75.75 0 0 0-.657.744Zm0 2.629c0 1.196.312 2.32.857 3.294A5.266 5.266 0 0 1 3.16 5.337c.663-.128 1.332-.243 2.006-.343v.256Zm13.5 0v-.256c.674.1 1.343.214 2.006.343a5.265 5.265 0 0 1-2.863 3.207c.545-.974.857-2.098.857-3.294Z",
}
const STROKE_ICONS = ["activity", "swap", "check"]
const SECTION_ORDER = ["Go to", "Actions"]
const SECTION_ICON = {
  Recent: "clock",
  "Compare this lap": "swap",
  "This session": "events",
  History: "clock",
  Friends: "friends",
  Leaderboard: "trophy",
  "Go to": "arrowr",
  Actions: "spark",
}
const RECENT_KEY = "apex-cmdk-recent"
const RECENT_MAX = 4
const REF_RECENT_KEY = "apex-cmdk-ref-recent"
const REF_RECENT_MAX = 4
const REF_TABS = [
  ["all", "All"],
  ["session", "This session"],
  ["history", "History"],
  ["friends", "Friends"],
  ["leaderboard", "Leaderboard"],
]

export default class extends Controller {
  static targets = [
    "dialog",
    "input",
    "list",
    "searchIcon",
    "back",
    "tabs",
    "vsYou",
  ]
  static values = { commands: Array }

  connect() {
    this.active = 0
    this.flat = []
    this.page = "root"
    this.refFilter = "all"
    this.ctx = null
    this.candidates = null // normalized groups array, or null until fetched
    this._fetching = false
    this._recent = this.readRecent(RECENT_KEY)
    this._refRecent = this.readRecent(REF_RECENT_KEY)
    this._byId = Object.fromEntries(this.commandsValue.map((i) => [i.id, i]))
    this._onHotkey = (e) => {
      if (!((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k")) return
      const el = document.activeElement
      if (
        !this.dialogTarget.open &&
        (el?.isContentEditable || el?.tagName === "TEXTAREA")
      )
        return
      e.preventDefault()
      this.toggle()
    }
    this._onOpenRefs = () => this.open({ page: "refs" })
    window.addEventListener("keydown", this._onHotkey)
    window.addEventListener("cmdk:open-refs", this._onOpenRefs)
  }

  disconnect() {
    window.removeEventListener("keydown", this._onHotkey)
    window.removeEventListener("cmdk:open-refs", this._onOpenRefs)
  }

  // ── open / close ──
  toggle() {
    if (this.dialogTarget.open) this.close()
    else this.open()
  }

  open(opts = {}) {
    this.ctx = this.readContext()
    let page = opts.page || "root"
    if (page === "refs" && !this.ctx) page = "root"
    const wasOpen = this.dialogTarget.open
    if (!wasOpen) {
      this.candidates = null
      this.active = 0
      this.dialogTarget.showModal()
    }
    this.setPage(page)
    if (this.ctx && !wasOpen) this.fetchCandidates()
    requestAnimationFrame(() => this.inputTarget.focus())
  }

  close() {
    if (this.dialogTarget.open) this.dialogTarget.close()
  }

  onDialogClose() {
    this.active = 0
    this.setPage("root")
  }

  onCancel(event) {
    // Esc on the refs page goes back to root instead of closing the dialog.
    if (this.page === "refs") {
      event.preventDefault()
      this.setPage("root")
    }
  }

  backdropClose(event) {
    if (event.target === this.dialogTarget) this.close()
  }

  backToRoot() {
    this.setPage("root")
    requestAnimationFrame(() => this.inputTarget.focus())
  }

  // ── page chrome ──
  setPage(page) {
    this.page = page
    this.refFilter = "all"
    this.active = 0
    this.inputTarget.value = ""
    const refs = page === "refs"
    this.inputTarget.placeholder = refs
      ? "Search laps, friends, references…"
      : "Search or jump to…"
    if (this.hasSearchIconTarget)
      this.searchIconTarget.classList.toggle("hidden", refs)
    if (this.hasBackTarget) this.backTarget.classList.toggle("hidden", !refs)
    if (this.hasTabsTarget) {
      this.tabsTarget.classList.toggle("hidden", !refs)
      if (refs) this.renderTabs()
    }
    this.renderVsYou()
    this.render()
  }

  renderTabs() {
    const tabs = REF_TABS.filter(([k]) => k === "all" || this.hasGroup(k))
    this.tabsTarget.innerHTML = tabs
      .map(
        ([k, label]) =>
          `<button type="button" data-action="click->cmdk#setRefFilter" data-key="${k}"
        class="cmdk-tab ${k === this.refFilter ? "cmdk-tab-active" : ""}">${this.escape(label)}</button>`,
      )
      .join("")
  }

  hasGroup(key) {
    return !!(
      this.candidates &&
      this.candidates.some((g) => g.key === key && g.items.length)
    )
  }

  setRefFilter(event) {
    this.refFilter = event.currentTarget.dataset.key
    this.active = 0
    this.renderTabs()
    this.render()
  }

  // ── context + candidates ──
  readContext() {
    const el = document.querySelector("[data-cmdk-context]")
    if (!el || !el.dataset.lapId) return null
    const d = el.dataset
    return {
      lapId: Number(d.lapId),
      lapTimeMs: Number(d.lapTimeMs) || 0,
      lapLabel: d.lapLabel || "this lap",
      trackLabel: d.trackLabel || "",
    }
  }

  async fetchCandidates() {
    if (!this.ctx || this.candidates || this._fetching) return
    this._fetching = true
    if (this.dialogTarget.open) this.render() // show loading state
    try {
      const resp = await fetch(
        `/laps/${this.ctx.lapId}/comparison_candidates`,
        { headers: { Accept: "application/json" } },
      )
      if (!resp.ok) throw new Error(`HTTP ${resp.status}`)
      this.candidates = this.normalize(await resp.json())
    } catch (e) {
      this.candidates = []
    } finally {
      this._fetching = false
      if (this.dialogTarget.open) {
        if (this.page === "refs" && this.hasTabsTarget) this.renderTabs()
        this.render()
      }
    }
  }

  normalize(json) {
    const groups = []
    const lapName = (c) => (c.label || "").split(" — ")[0] || c.label

    const session = (json.this_session || []).map((c) => ({
      id: c.id,
      name: lapName(c),
      sub: null,
      timeMs: c.time_ms,
      icon: "events",
      chip: "lap",
    }))
    if (session.length)
      groups.push({ key: "session", label: "This session", items: session })

    const history = (json.history || []).map((c) => ({
      id: c.id,
      name: lapName(c),
      sub: c.when,
      timeMs: c.time_ms,
      icon: "events",
      chip: "lap",
    }))
    if (history.length)
      groups.push({ key: "history", label: "History", items: history })

    const friends = (json.friends || []).map((c) => ({
      id: c.id,
      name: c.driver,
      sub: "Friend",
      timeMs: c.time_ms,
      icon: "friends",
      avatar: {
        initials: this.initials(c.driver),
        colorIdx: this.avatarIndex(c.driver),
      },
    }))
    if (friends.length)
      groups.push({ key: "friends", label: "Friends", items: friends })

    const leaderboard = (json.leaderboard || []).map((c) => ({
      id: c.id,
      name: c.driver,
      sub: c.is_you ? "You" : null,
      timeMs: c.time_ms,
      icon: "trophy",
      chip: "gold",
    }))
    if (leaderboard.length)
      groups.push({
        key: "leaderboard",
        label: "Leaderboard",
        items: leaderboard,
      })

    return groups
  }

  initials(name) {
    return (
      String(name || "")
        .trim()
        .split(/\s+/)
        .map((w) => w[0])
        .filter(Boolean)
        .slice(0, 2)
        .join("")
        .toUpperCase() || "?"
    )
  }

  avatarIndex(name) {
    let h = 0
    for (const ch of String(name || "")) h = (h * 31 + ch.charCodeAt(0)) >>> 0
    return h % 8
  }

  get allRefs() {
    return (this.candidates || []).flatMap((g) => g.items)
  }

  // ── recents ──
  readRecent(key) {
    try {
      return JSON.parse(localStorage.getItem(key) || "[]")
    } catch (e) {
      return []
    }
  }

  pushRecent(id) {
    this._recent = [id, ...this._recent.filter((x) => x !== id)].slice(
      0,
      RECENT_MAX,
    )
    try {
      localStorage.setItem(RECENT_KEY, JSON.stringify(this._recent))
    } catch (e) {}
  }

  pushRefRecent(id) {
    this._refRecent = [id, ...this._refRecent.filter((x) => x !== id)].slice(
      0,
      REF_RECENT_MAX,
    )
    try {
      localStorage.setItem(REF_RECENT_KEY, JSON.stringify(this._refRecent))
    } catch (e) {}
  }

  // ── run ──
  run(item) {
    if (this.page === "refs") {
      this.applyRef(item)
      return
    }
    if (typeof item.run === "function") {
      item.run()
      return
    } // dynamic compare items
    this.pushRecent(item.id)
    this.close()
    if (item.kind === "route") window.Turbo.visit(item.route)
    else if (item.kind === "action" && item.id === "act:toggle-theme")
      this.toggleTheme()
  }

  applyRef(c) {
    this.pushRefRecent(c.id)
    set("comparisonLapId", c.id)
    set("comparisonLapLabel", `${c.name} · ${this.fmtLap(c.timeMs)}`)
    this.close()
  }

  clearRef() {
    set("comparisonLapId", null)
    set("comparisonLapLabel", null)
    this.close()
  }

  toggleTheme() {
    const mq = window.matchMedia("(prefers-color-scheme: dark)")
    let current
    try {
      current = localStorage.getItem("appearance")
    } catch (e) {}
    current = current || "system"
    const isDark = current === "dark" || (current === "system" && mq.matches)
    const mode = isDark ? "light" : "dark"
    try {
      localStorage.setItem("appearance", mode)
    } catch (e) {}
    document.documentElement.classList.toggle("dark", mode === "dark")
    window.dispatchEvent(
      new CustomEvent("appearance:change", { detail: { mode } }),
    )
  }

  // ── input + keys ──
  filter() {
    this.active = 0
    this.render()
  }

  // Bound on the <dialog> (not just the input) so arrow/Enter nav works even when
  // focus is on a tab/button inside the palette. stopPropagation keeps the keys
  // from reaching window-level handlers (e.g. the lap-list arrow nav) while open.
  onKeydown(event) {
    if (event.key === "ArrowDown") {
      event.preventDefault()
      event.stopPropagation()
      this.active = Math.min(this.flat.length - 1, this.active + 1)
      this.highlight()
    } else if (event.key === "ArrowUp") {
      event.preventDefault()
      event.stopPropagation()
      this.active = Math.max(0, this.active - 1)
      this.highlight()
    } else if (event.key === "Enter") {
      event.preventDefault()
      event.stopPropagation()
      const item = this.flat[this.active]
      if (item) this.run(item)
    } else if (
      event.key === "Backspace" &&
      this.inputTarget.value === "" &&
      this.page === "refs"
    ) {
      event.preventDefault()
      event.stopPropagation()
      this.setPage("root")
    }
    // Escape: native <dialog> cancel → onCancel (back on refs, close on root).
  }

  // "VS YOU · <your lap time>" in the search header — the comparison baseline.
  // Only shown in the compare submenu (refs page), where every row is a gap-to-you.
  renderVsYou() {
    if (!this.hasVsYouTarget) return
    const show = !!this.ctx && this.page === "refs"
    this.vsYouTarget.textContent = show
      ? `VS YOU · ${this.fmtLap(this.ctx.lapTimeMs)}`
      : ""
    this.vsYouTarget.classList.toggle("hidden", !show)
  }

  // ── sections ──
  rootSections() {
    const q = this.inputTarget.value.trim().toLowerCase()
    const has = (it) =>
      !q ||
      it.label.toLowerCase().includes(q) ||
      (it.keywords || it.sub || "").toLowerCase().includes(q)
    const grouped = {}
    this.commandsValue.filter(has).forEach((it) => {
      ;(grouped[it.section] ||= []).push(it)
    })

    const sections = []
    if (!q) {
      const recentItems = this._recent
        .map((id) => this._byId[id])
        .filter(Boolean)
        .slice(0, RECENT_MAX)
      if (recentItems.length)
        sections.push({ title: "Recent", items: recentItems })
    }
    if (this.ctx) {
      const items = this.compareItems().filter(has)
      if (items.length) sections.push({ title: "Compare this lap", items })
    }
    SECTION_ORDER.forEach((s) => {
      if (grouped[s]?.length) sections.push({ title: s, items: grouped[s] })
    })
    return sections
  }

  compareItems() {
    const items = [
      {
        id: "cmp-browse",
        kind: "compare",
        icon: "swap",
        accent: true,
        label: "Compare against a lap…",
        sub: "this session · history · friends · leaderboard",
        run: () => this.setPage("refs"),
      },
    ]
    for (const g of this.candidates || []) {
      const c = g.items[0]
      if (!c) continue
      if (items.length > 3) break
      items.push({
        id: "cmp-apply-" + c.id,
        kind: "compare-apply",
        icon: c.icon,
        label: c.name,
        sub: g.label,
        gapMs: this.ctx.lapTimeMs - c.timeMs,
        run: () => this.applyRef(c),
      })
    }
    if (get("comparisonLapId")) {
      items.push({
        id: "cmp-clear",
        kind: "compare",
        icon: "close",
        accent: true,
        label: "Clear comparison",
        run: () => this.clearRef(),
      })
    }
    return items
  }

  refSections() {
    const q = this.inputTarget.value.trim().toLowerCase()
    const match = (it) =>
      !q || `${it.name} ${it.sub || ""}`.toLowerCase().includes(q)
    const sections = []
    const recentIds = new Set()
    if (!q && this.refFilter === "all" && this._refRecent.length) {
      const recent = this._refRecent
        .map((id) => this.allRefs.find((c) => c.id === id))
        .filter(Boolean)
      if (recent.length) {
        recent.forEach((c) => recentIds.add(c.id))
        sections.push({ title: "Recent", ref: true, items: recent })
      }
    }
    ;(this.candidates || [])
      .filter((g) => this.refFilter === "all" || g.key === this.refFilter)
      .forEach((g) => {
        const items = g.items.filter((it) => match(it) && !recentIds.has(it.id))
        if (items.length) sections.push({ title: g.label, ref: true, items })
      })
    return sections
  }

  // ── render ──
  render() {
    const refs = this.page === "refs"
    const sections = refs ? this.refSections() : this.rootSections()
    this.flat = sections.flatMap((s) => s.items)
    this.active = Math.min(this.active, Math.max(0, this.flat.length - 1))

    if (this.flat.length === 0) {
      this.listTarget.innerHTML =
        refs && this._fetching
          ? this.loadingMarkup()
          : this.emptyMarkup(this.inputTarget.value.trim(), refs)
      return
    }

    let idx = -1
    this.listTarget.innerHTML = sections
      .map(
        (s) => `
      <div class="mb-1">
        <div class="flex items-center gap-1.5 px-2.5 py-1 font-mono text-[10px] font-semibold uppercase tracking-[0.14em] text-app-text-faint">
          ${this.iconSvg(SECTION_ICON[s.title] || (s.ref ? "events" : "spark"), 11)} ${this.escape(s.title)}
        </div>
        ${s.items
          .map((it) => {
            idx += 1
            return s.ref ? this.refRowMarkup(it, idx) : this.rowMarkup(it, idx)
          })
          .join("")}
      </div>`,
      )
      .join("")

    this.highlight()
  }

  rowMarkup(it, i) {
    const accent = it.accent || it.kind === "action"
    const iconWrap = "cmdk-chip" + (accent ? " cmdk-chip-accent" : "")
    const gap =
      it.gapMs != null
        ? `<span class="font-mono text-[12px] font-bold tabular-nums ${it.gapMs > 0 ? "cmdk-gap-loss" : "cmdk-gap-gain"}">${this.fmtGap(it.gapMs)}</span>`
        : ""
    const trail =
      (it.kind === "route" || it.kind === "compare") && it.id !== "cmp-clear"
        ? "chevronr"
        : "arrowr"
    return `
      <button type="button" data-idx="${i}" data-cmdk-row
        class="cmdk-row group flex w-full items-center gap-3 rounded-xl px-2.5 py-2 text-left">
        <span class="${iconWrap} grid h-7 w-7 shrink-0 place-items-center rounded-lg">
          ${this.iconSvg(it.icon, 15)}
        </span>
        <span class="min-w-0 flex-1">
          <span class="block font-display text-[13.5px] font-medium text-app-text">${this.escape(it.label)}</span>
          ${it.sub ? `<span class="block font-mono text-[11px] text-app-text-faint">${this.escape(it.sub)}</span>` : ""}
        </span>
        ${gap}
        ${this.iconSvg(trail, 14, "cmdk-row-arrow text-app-text-faint")}
      </button>`
  }

  refRowMarkup(it, i) {
    const gapMs = this.ctx ? this.ctx.lapTimeMs - it.timeMs : 0
    const current = get("comparisonLapId") === it.id
    const visual = it.avatar
      ? `<span class="cmdk-avatar cmdk-avatar-${it.avatar.colorIdx} grid h-7 w-7 shrink-0">${this.escape(it.avatar.initials)}</span>`
      : `<span class="cmdk-chip ${it.chip ? "cmdk-chip--" + it.chip : ""} grid h-7 w-7 shrink-0 place-items-center rounded-lg">${this.iconSvg(it.icon || "events", 15)}</span>`
    return `
      <button type="button" data-idx="${i}" data-cmdk-row
        class="cmdk-row group flex w-full items-center gap-3 rounded-xl px-2.5 py-2 text-left">
        ${visual}
        <span class="min-w-0 flex-1">
          <span class="block truncate font-display text-[13px] font-semibold text-app-text">${this.escape(it.name)}</span>
          ${it.sub ? `<span class="block font-mono text-[11px] text-app-text-faint">${this.escape(it.sub)}</span>` : ""}
        </span>
        <span class="font-mono text-[12.5px] font-semibold tabular-nums text-app-text">${this.fmtLap(it.timeMs)}</span>
        <span class="w-[58px] text-right font-mono text-[12px] font-bold tabular-nums ${gapMs > 0 ? "cmdk-gap-loss" : "cmdk-gap-gain"}">${this.fmtGap(gapMs)}</span>
        ${current ? this.iconSvg("check", 16, "cmdk-gap-gain") : this.iconSvg("arrowr", 14, "cmdk-row-arrow text-app-text-faint")}
      </button>`
  }

  // ── delegated row events ──
  onListHover(event) {
    const row = event.target.closest("[data-cmdk-row]")
    if (!row) return
    this.active = Number(row.dataset.idx)
    this.highlight()
  }

  onListClick(event) {
    const row = event.target.closest("[data-cmdk-row]")
    if (!row) return
    const item = this.flat[Number(row.dataset.idx)]
    if (item) this.run(item)
  }

  highlight() {
    this.listTarget.querySelectorAll("[data-cmdk-row]").forEach((el) => {
      const on = Number(el.dataset.idx) === this.active
      el.classList.toggle("cmdk-row-active", on)
      if (on) el.scrollIntoView({ block: "nearest" })
    })
  }

  // ── formatting / misc markup ──
  fmtLap(ms) {
    if (!ms || ms <= 0) return "—"
    const totalS = Math.floor(ms / 1000),
      millis = ms % 1000,
      m = Math.floor(totalS / 60),
      s = totalS % 60
    return m > 0
      ? `${m}:${String(s).padStart(2, "0")}.${String(millis).padStart(3, "0")}`
      : `${s}.${String(millis).padStart(3, "0")}`
  }

  fmtGap(ms) {
    const s = ms / 1000
    return (s >= 0 ? "+" : "−") + Math.abs(s).toFixed(3)
  }

  loadingMarkup() {
    return `<div class="flex items-center justify-center gap-2 py-12 text-[13px] text-app-text-muted">Loading references…</div>`
  }

  emptyMarkup(q, refs) {
    const msg = refs
      ? q
        ? `No references for &ldquo;${this.escape(q)}&rdquo;`
        : "No comparison laps available"
      : `No results for &ldquo;${this.escape(q)}&rdquo;`
    return `
      <div class="flex flex-col items-center gap-2 py-12 text-center">
        ${this.iconSvg("search", 22, "text-app-text-faint")}
        <div class="text-[13px] text-app-text-muted">${msg}</div>
      </div>`
  }

  iconSvg(name, size, cls = "") {
    const stroke = STROKE_ICONS.includes(name)
    const d = ICONS[name] || ICONS.help
    return (
      `<svg width="${size}" height="${size}" viewBox="0 0 24 24" ` +
      `fill="${stroke ? "none" : "currentColor"}" stroke="${stroke ? "currentColor" : "none"}" ` +
      `stroke-width="${stroke ? 2 : 0}" stroke-linecap="round" stroke-linejoin="round" ` +
      `class="shrink-0 ${cls}" aria-hidden="true"><path d="${d}"/></svg>`
    )
  }

  escape(s) {
    return String(s).replace(
      /[&<>"']/g,
      (c) =>
        ({
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#39;",
        })[c],
    )
  }
}
